import BackgroundImageComponent from '@components/common/background-image'
import { FastlyImage, LazyImage } from '@components/common/image'

const IMAGE_PATH = '/images/teacher-lp/becoming-a-teacher/'

type Props = {
  handleBecomeTeacher: () => void
}

const BecomingATeacher = ({ handleBecomeTeacher }: Props) => (
  <>
    <div className="container mx-auto relative" id="becoming-a-teacher">
      <div className="mx-4 mt-16 md:mt-24 md:mx-10">
        <FastlyImage
          src={`${IMAGE_PATH}become-a-teacher.png`}
          alt="becoming-a-teacher image"
          height="500"
          width="1800"
        />
      </div>
      <div className="flex flex-col items-center justify-center px-4 pt-6 pb-3 relative">
        <p className="font-700 text-3xl md:text-4xl text-center md:text-left text-grey-900">
          5 steps to becoming a teacher
        </p>
        <LazyImage
          path="/images/teacher-lp/"
          name="line"
          className="max-w-4/5"
          alt="line image"
        />
        <BackgroundImageComponent
          image={`${IMAGE_PATH}steps-line.png`}
          top={180}
          left={19}
          width={22}
          className="hidden md:block"
        />
      </div>
      <div className="md:grid md:justify-center px-4 md:px-0 mt-12 md:mt-16">
        <div className="flex flex-col gap-10 md:gap-40 md:items-baseline">
          <div className="flex gap-10 md:gap-20 item-center flex-col md:flex-row md:ml-32">
            <div className="flex justify-center md:block">
              <FastlyImage
                src={`${IMAGE_PATH}submit-your-application.png`}
                alt="submit-your-application"
                height="192"
                width="192"
              />
            </div>
            <div className="flex flex-col justify-center md:w-128 text-grey-900 text-center md:text-left">
              <div className="flex flex-col">
                <p className="text-xl font-600 text-orange">Step 1</p>
                <p className="text-3xl font-600">Submit your application</p>
              </div>
              <p className="font-400 text-xl">
                Sign up as a teacher, verify your phone number, and provide some
                basic information about yourself.
              </p>
            </div>
          </div>

          <div className="flex gap-10 md:gap-20 item-center flex-col md:flex-row-reverse md:ml-24">
            <div className="flex justify-center md:block">
              <FastlyImage
                src={`${IMAGE_PATH}share-a-demo-video.png`}
                alt="share-a-demo-video"
                height="192"
                width="192"
              />
            </div>
            <div className="flex flex-col justify-center md:w-128 text-grey-900 text-center md:text-left">
              <div className="flex flex-col">
                <p className="text-xl font-600 text-orange">Step 2</p>
                <p className="text-3xl font-600">Share a demo video</p>
              </div>
              <p className="font-400 text-xl">
                Upload a short 2 to 5 minute video of yourself explaining a
                concept, subject or topic of your choice. This is your chance to
                show off your skills. So make the most of it.
              </p>
            </div>
          </div>

          <div className="flex gap-10 md:gap-20 item-center flex-col md:flex-row md:pt-2 md:ml-32">
            <div className="flex justify-center md:block">
              <FastlyImage
                src={`${IMAGE_PATH}take-technical-assessment.png`}
                alt="take-technical-assessment"
                height="192"
                width="192"
              />
            </div>
            <div className="flex flex-col justify-center md:w-128 text-grey-900 text-center md:text-left">
              <div className="flex flex-col">
                <p className="text-xl font-600 text-orange">Step 3</p>
                <p className="text-3xl font-600">Take technical assessment</p>
              </div>
              <p className="font-400 text-xl">
                We will give you a small test to complete. This will help us
                assess your technical knowledge and skill level.
              </p>
            </div>
          </div>

          <div className="flex gap-10 md:gap-20 item-center flex-col md:flex-row-reverse md:pt-8 md:ml-24">
            <div className="flex justify-center md:block">
              <FastlyImage
                src={`${IMAGE_PATH}do-an-interview.png`}
                alt="do-an-interview"
                height="160"
                width="200"
              />
            </div>
            <div className="flex flex-col justify-center md:w-128 text-grey-900 text-center md:text-left">
              <div className="flex flex-col">
                <p className="text-xl font-600 text-orange">Step 4</p>
                <p className="text-3xl font-600">Do an interview</p>
              </div>
              <p className="font-400 text-xl">
                If your skill and qualifications meet our expectations,
                you&apos;ll hear from us to set up a round of interviews.
              </p>
            </div>
          </div>

          <div className="flex gap-10 md:gap-20 item-center flex-col md:flex-row md:-m-2 md:ml-16">
            <div className="flex justify-center md:block">
              <FastlyImage
                src={`${IMAGE_PATH}get-hired!.png`}
                className="w-48 inline-block"
                alt="get-hired!"
                height="280"
                width="192"
              />
            </div>

            <div className="flex flex-col justify-center md:w-128 text-grey-900 text-center md:text-left">
              <div className="flex flex-col">
                <p className="text-xl font-600 text-orange">Step 5</p>
                <p className="text-3xl font-600">Get hired!</p>
              </div>
              <p className="font-400 text-xl">
                If all goes well, you will be informed about our decision to
                hire you as a teacher, and you&apos;ll be teaching kids to code
                in no time!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="md:flex md:justify-center pt-8 md:pt-10 px-4 md:px-0">
      <button
        onClick={handleBecomeTeacher}
        className="btn btn-orange py-3 md:text-xl text-2xl text-center md:text-left font-600 w-full md:w-auto mt-12 md:mt-20"
      >
        Become a teacher
      </button>
    </div>
  </>
)

export default BecomingATeacher
